export default class HorizontalMenu {

  static readonly CONTROL_PREV_SELECTOR = '[data-horizontal-menu-click="prev"]';
  static readonly CONTROL_NEXT_SELECTOR = '[data-horizontal-menu-click="next"]';
  static readonly NAV_SELECTOR = '[data-horizontal-menu-nav]';
  static readonly NAV_ITEM_SELECTOR = '[data-horizontal-menu-item]';

  private readonly nav: Element;
  private readonly prevControlList: NodeListOf<Element>;
  private readonly nextControlList: NodeListOf<Element>;

  constructor(
    private readonly element: Element,
  ) {
    this.nav = element.querySelector(HorizontalMenu.NAV_SELECTOR);
    this.prevControlList = this.nav.querySelectorAll(HorizontalMenu.CONTROL_PREV_SELECTOR);
    this.nextControlList = this.nav.querySelectorAll(HorizontalMenu.CONTROL_NEXT_SELECTOR);

    this.initControl();
    this.initResize();
    this.handleControlsDisplay();
  }

  next() {
    const viewPortWidth = this.getViewPortWidth();
    const scroll = this.getCurrentScroll();
    const navWidth = this.getNavWidth();
    const widthLeft = navWidth - scroll - viewPortWidth;

    let finalScrollWidth = 0;

    if (widthLeft <= viewPortWidth) {
      finalScrollWidth = widthLeft + scroll;
    } else {
      finalScrollWidth = viewPortWidth + scroll;
    }

    this.move(finalScrollWidth);
  }

  prev() {
    const viewPortWidth = this.getViewPortWidth();
    const widthLeft = this.getCurrentScroll();
    let finalScrollWidth = 0;

    if (widthLeft <= viewPortWidth) {
      finalScrollWidth = 0;
    } else {
      finalScrollWidth = widthLeft - viewPortWidth;
    }

    this.move(finalScrollWidth);
  }

  private move(scroll: number) {
    this.nav.setAttribute('style', `margin-left: -${scroll}px`);

    setTimeout(() => {
      this.handleControlsDisplay();
    }, 300);
  }

  private getCurrentScroll(): number {
    return -parseInt(window.getComputedStyle(this.nav).marginLeft);
  }

  private getViewPortWidth() {
    return this.element.clientWidth;
  }

  private getNavWidth(): number {
    return this.nav.scrollWidth;
  }

  private initControl() {
    this.nextControlList.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.next();
      });
    });

    this.prevControlList.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        this.prev();
      });
    });
  }

  // Handle unlimited menu responsive setting
  private initResize() {
    let timer;

    window.addEventListener('resize', () => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        this.scrollToActiveItem();
        this.handleControlsDisplay();
      }, 150);
    });
  }

  private scrollToActiveItem() {
    const calculatePreviousElementsWidth = (element: Element) => {
      const itemList = this.nav.querySelectorAll(HorizontalMenu.NAV_ITEM_SELECTOR);
      let width = 0;

      for (let i = 0; i < itemList.length; i++) {
        if (itemList[i] === element) {
          break;
        }

        width += itemList[i].clientWidth;
      }

      return width;
    };

    const targetActiveItem = this.nav.querySelector(`${HorizontalMenu.NAV_ITEM_SELECTOR}.active`);
    const viewPortWidth = this.getViewPortWidth();
    const scroll = this.getCurrentScroll();
    const prevWidth = targetActiveItem ? calculatePreviousElementsWidth(targetActiveItem) : 0;

    if (prevWidth >= viewPortWidth + scroll) {
      let finalScrollWidth = prevWidth - viewPortWidth + (targetActiveItem ? targetActiveItem.clientWidth : 0);

      this.move(finalScrollWidth);
    } else if (prevWidth < scroll) {
      this.move(prevWidth);
    }
  }

  // Handle the display of controls
  private handleControlsDisplay() {
    const scroll = this.getCurrentScroll();
    const viewPortView = this.getViewPortWidth();
    const navWidth = this.getNavWidth();

    if (navWidth - scroll > viewPortView) {
      HorizontalMenu.show(Array.from(this.nextControlList));
    } else {
      HorizontalMenu.hide(Array.from(this.nextControlList));
    }

    if (scroll > 0) {
      HorizontalMenu.show(Array.from(this.prevControlList));
    } else {
      HorizontalMenu.hide(Array.from(this.prevControlList));
    }
  }

  private static show(list: Array<Element> | NodeList) {
    list.forEach(item => {
      item.classList.add('show');
    });
  }

  private static hide(list: Array<Element> | NodeList) {
    list.forEach(item => {
      item.classList.remove('show');
    });
  }
}
